<template>
  <div>
    <div
      v-if="policy"
      :class="{
        'mt-8': !maxDevice('md') && padding,
        'mt-4': maxDevice('md') && padding,
        'mx-auto': !app.isTeemill && padding,
        container: app.isTeemill && padding,
        'mb-16 mt-16': padding,
      }"
    >
      <tml-render-html-editor-output id="policy" :html="policy.contents" />
    </div>
    <div
      v-show="policy"
      ref="endOfPolicyMarker"
      class="w-full"
      style="height: 10px"
    />
  </div>
</template>

<script>
import {formatUrl, maxDevice} from '@teemill/common/helpers';
import {startCase} from '@teemill/utilities';
import {computed} from 'vue';
import {useHead} from '@vueuse/head';

export default {
  name: 'PolicyViewer',

  inject: ['app'],

  props: {
    urlName: {
      type: String,
      required: true,
    },

    updateTitle: {
      type: Boolean,
      default: false,
    },

    padding: {
      type: Boolean,
      default: true,
    },

    index: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      policy: null,
      scrolledToBottom: false,
      intersectionObserver: null,
    };
  },

  watch: {
    policy() {
      this.intersectionObserver = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
              this.$emit('read', true);
            }
          });
        },
        {
          rootMargin: '500px',
          trackVisibility: false,
          threshold: [0.0],
        }
      );

      this.intersectionObserver.observe(this.$refs.endOfPolicyMarker);
    },

    urlName() {
      this.getPolicy();
    },
  },

  mounted() {
    this.getPolicy();
  },

  created() {
    useHead(
      computed(() => {
        const metaInfo = {
          title: $store.state.title,
        };

        if (!this.index) {
          metaInfo.meta = [{name: 'robots', content: 'noindex'}];
        }

        return metaInfo;
      })
    );
  },

  methods: {
    getPolicy() {
      this.axios
        .post(formatUrl('/omnis/v3/eula/getFromUrl/'), {
          url: this.urlName,
        })
        .success(data => {
          this.policy = data;

          if (this.updateTitle) {
            document.title = `${this.policy.name} | ${startCase(
              this.app.name
            )}`;
          }

          this.$emit('loaded');
        })
        .validation(() => {
          this.$router.replace('/404/');
        })
        .oops();
    },

    maxDevice,
  },
};
</script>
